<template>
  <div>
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <navicat background="#ffffff" :current="3"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="boxy-content">
      <div class="inner w-1400">
        <div class="bread-crumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>原料供应专区</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 搜索框 -->
        <div class="content-search">
          <div class="content-search-box">
            <el-input
                placeholder="请输入CAS号、中文名称、英文名称"
                v-model="keyword"
                @input="changeFun"
            >
              <el-button @click="searchFun" slot="append" class="search-btn">搜索</el-button>
            </el-input>
          </div>
        </div>
        <!--        v-loading="loading"-->
        <div class="content-body">
          <div class="card-list" v-if="loading">
            <el-skeleton
                style="width: 311px;height: 310px;display: flex;flex-direction: column;justify-content: space-between;"
                v-for="i in 12" :key="i">
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 100%; height: 150px;"/>
                <div
                    style="padding: 8px 0; display: flex;flex-direction: column;justify-content: space-between;height: 160px">
                  <el-skeleton-item variant="p" style="width: 100%;height: 24px"/>
                  <div style="display: flex; align-items: center; justify-content: space-between;margin: 10px 0">
                    <el-skeleton-item variant="text" style="width: 30%;height: 20px"/>
                    <el-skeleton-item variant="text" style="width: 30%;height: 20px"/>
                    <el-skeleton-item variant="text" style="width: 30%;height: 20px"/>
                  </div>
                  <el-skeleton-item variant="p" style="width: 100%;height: 20px"/>
                  <div style="display: flex; align-items: center; justify-content: space-between;margin: 10px 0">
                    <el-skeleton-item variant="text" style="width: 55%;height: 24px"/>
                    <el-skeleton-item variant="text" style="width: 30%;height: 24px"/>
                  </div>
                </div>
              </template>
            </el-skeleton>
          </div>
          <!--          卡片列表-->
          <div class="card-list" v-else>
            <div class="purchase-card" v-for="(data,index) in productList" :key="index">

              <div>
                <img
                    class="card-icon"
                    :src="require('@/static/index/shop/new.png')"
                    alt="描述背景"
                />
              </div>

              <div class="top-inner">
                <div class="goods-image-box">
                  <img
                      @click="goOrderInner(data)"
                      class="goods-image"
                      :src="data.image"
                      alt="商品图片"
                  />
                </div>
                <div class="card-title">{{ data.product_name }}</div>
                <div class="card-info">
                  <span>{{ data.cas_no }}</span>
                  <template v-if="data.skuone">
                    <span class="card-info-wait">{{ data.skuone.number }}{{ data.skuone.unit }}</span>
                    <span v-if="data.skuone.invoice_type == 1"> 专票(13%) </span>
                    <span v-else> 普票 </span>
                  </template>
                  <template v-else>
                    <span class="card-info-wait">暂未设置</span>
                    <span> 暂未设置 </span>
                  </template>
                </div>
              </div>
              <div class="card-footer">
      <span class="card-footer-text"
      >已有<span class="card-footer-text-num">{{ data.supplier_count }}</span>
        家供应商</span
      >
                <div></div>
                <gradient-button fontSize="14px" @hit="goQuote" height="30px">联系业务</gradient-button>
              </div>
            </div>
          </div>

          <!--       分页-->
          <Empty v-if="productList.length==0&&!loading"></Empty>
          <div class="pagination-box" v-else>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="pageNum"
                           :page-sizes="[20, 40, 80, 100]"
                           :page-size="pageSize" background
                           layout="sizes, prev, pager, next" :total="total">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>
    <!-- 联系客服 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               :title="dialogTitle" :modal="false" top="20vh" :visible.sync="dialogVisible" width="30%"
               :before-close="handleClose">
      <span class="dialog-content">业务：{{ kefu.name }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
      <span class="dialog-content" @click="$utils.copyText(kefu)">联系方式：{{ kefu.mobile }} <i
          class="el-icon-copy-document"></i>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "../../components/public/home-top.vue";
import topSearch from "../../components/public/top-search.vue";
import navicat from "../../components/navicat/navicat.vue";
import homeFooter from "../../components/public/home-footer.vue";
import Empty from "../../components/public/empty.vue";
import gradientButton from "../../components/button/gradient-button.vue";
import {supplyZone} from "@/api/modules/home";
import {getMyCustomerService} from "@/api/modules/user";

export default {
  name: "purchase",
  components: {
    Empty,
    homeTop,
    topSearch,
    navicat,
    homeFooter,
    gradientButton
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      total: 1,
      keyword: "",
      productList: [],
      dialogVisible: false,
      dialogTitle: '',
      kefu: "",
      loading: true
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.user.isLogin
    },
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  mounted() {
    this.getList();
    this.getKefu()
  },
  methods: {
    goOrderInner(data) {
      this.$router.push({
        path: "/search",
        query: {id: data.product_id},
      });
    },
    changeFun(e) {
      if (!e.trim()) {
        this.pageNum = 1
        this.productList = []
        this.loading = true
        this.getList()
      }
    },
    searchFun() {
      if (this.keyword.trim()) {
        this.pageNum = 1
        this.productList = []
        this.loading = true
        this.getList()
      }
    },
    async getList() {
      let res = await supplyZone({
        keywords: this.keyword,
        limit: this.pageSize,
        page: this.pageNum
      })
      if (res.data.code == 10000) {
        this.loading = false
        this.productList = res.data.data.data
        this.total = res.data.data.total
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
      this.getList()
    },
    getKefu() {
      if (this.isLogin) {
        getMyCustomerService().then(res => {
          this.kefu = res.data.data.yewu
        })
      }
    },
    goQuote() {
      if (this.mixCheckLogin()) {

        this.dialogVisible = true;
        this.dialogTitle = "联系业务";
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.h-top {
  height: 265px;
}

.boxy-content {
  .inner {
    .cart-gray {
      padding: 50px 0 20px;
    }
  }

  .bread-crumb {
    margin: 20px 0;
  }

  .content-search {
    margin-bottom: 20px;

    .content-search-box {
      width: 516px;
      height: 40px;

      .search-btn {
        width: 100px;
        height: 40px;
        background: #4b87ff;
        border-radius: 0px 6px 6px 0px;
        text-align: center;
        //font-size: 20px;
        // line-height: 63px;
        color: #fff;
      }

      ::v-deep .el-input__inner {
        height: 40px !important;
      }

      ::v-deep .el-input {
        height: 40px !important;
      }
    }
  }

  .content-body {
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    padding: 30px;
    min-height: 400px;
    margin: 0 0 80px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .pagination-box {
      padding: 68px 0 0;
      text-align: right;
    }

    .card-list {
      flex: 1;
      //display: flex;
      //display: grid;
      //gap: 21px 29px;
      //flex-wrap: wrap;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(311px, 1fr));
      gap: 21px 29px;

      .purchase-card {
        position: relative;
        width: 311px;
        height: 300px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #d8d8d8;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding-bottom: 20px;

        .card-icon {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
        }

        .text-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 120px;
          height: 33px;
          z-index: 1;
          font-weight: 400;
          font-size: var(--font-size-default-14);
          color: #f8bb7d;
          text-align: center;
          line-height: 30px;
        }

        .top-inner {
          text-align: center;
          padding: 24px 20px 0;

          .goods-image-box {
            width: 100%;
            height: 131px;
            text-align: center;

            .goods-image {
              width: 80%;
              height: 131px;
              object-fit: contain;
            }
          }

          .card-title {
            font-weight: bold;
            font-size: var(--font-size-default-16);
            color: #424242;
            line-height: 28px;
          }

          .card-info {
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: var(--font-size-default-14);
            color: #5f616c;
            margin: 6px 0 12px;

            .card-info-wait {
              width: 35%;
              border-left: 1px solid #afafaf;
              border-right: 1px solid #afafaf;
            }
          }

          .card-time {
            font-weight: 400;
            font-size: var(--font-size-default-14);
            color: #afafaf;
          }
        }

        .card-footer {
          padding: 0px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .card-footer-text {
            font-weight: 400;
            font-size: var(--font-size-default-14);
            color: #00112b;

            .card-footer-text-num {
              color: #fe3c3c;
              font-weight: bold;
              font-size: 18px;
            }
          }

          .card-footer-button {
            width: 118px;
            height: 30px;
            background: rgba(12, 96, 230, 0.1);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #2979f1;
            font-weight: 400;
            font-size: var(--font-size-default-14);
            color: #0c60e6;
            text-align: center;
            line-height: 30px;
          }
        }
      }
    }
  }


  //.goods-list-box {
  //  background: #fff;
  //  padding: 50px 30px;
  //  margin-bottom: 35px;
  //
  //  .goods-list {
  //    display: flex;
  //    gap: 10px 4px;
  //    flex-wrap: wrap;
  //  }
  //
  //  .pagination {
  //    float: right;
  //    // transform: scale(1.5);
  //    margin: 60px 0;
  //  }
  //}
}

.height-200 {
  height: 134px;
}
</style>
